import { useWagmiAuth } from 'app/providers';
import { useAccount } from 'wagmi';

export const useIsAuthedAddress = () => {
  const { state } = useWagmiAuth();
  const { address } = useAccount();

  return !!address && state.isAuthorized;
};
